import { TaxonomyMainCategories } from "../../../common/categories";
import { GradientColors } from "../../../helpers/segment";

export const statusGradientColors: Record<
    TaxonomyMainCategories,
    GradientColors
> = {
    income: {
        start: "#B3E3FF",
        subtitle: "#0f182680",
    },
    advertising_marketing: {
        start: "#FFBBCD",
        subtitle: "#0f182680",
    },
    auto_vehicle: {
        start: "#E0E6E8",
        subtitle: "#0f182680",
    },
    communications: {
        start: "#E4F1BD",
        subtitle: "#0f182680",
    },
    learning_development: {
        start: "#BEF2F1",
        subtitle: "#0f182680",
    },
    entertainment: {
        start: "#EBBEF3",
        subtitle: "#0f182680",
    },
    fees: {
        start: "#FFE9BE",
        subtitle: "#0f182680",
    },
    insurance: {
        start: "#D1DEF4",
        subtitle: "#0f182680",
    },
    legal_professional: {
        start: "#D1D3F1",
        subtitle: "#0f182680",
    },
    meals: {
        start: "#FFD6BB",
        subtitle: "#0f182680",
    },
    payroll: {
        start: "#C1F1D8",
        subtitle: "#0f182680",
    },
    repairs_maintenance: {
        start: "#DBE7EE",
        subtitle: "#0f182680",
    },
    software_subscriptions: {
        start: "#E1C5FF",
        subtitle: "#0f182680",
    },
    taxes: {
        start: "#FCBDBD",
        subtitle: "#0f182680",
    },
    travel: {
        start: "#C2C4FB",
        subtitle: "#0f182680",
    },
    utilities: {
        start: "#E9E47C",
        subtitle: "#0f182680",
    },
    supplies_equipment: {
        start: "#E5D5D5",
        subtitle: "#0f182680",
    },
    credit_card_loans: {
        start: "#FFC4BE",
        subtitle: "#0f182680",
    },
    transfer: {
        start: "#DFCBE8",
        subtitle: "#0f182680",
    },
    contributions_distributions: {
        start: "#F2C0C0",
        subtitle: "#0f182680",
    },
    health_dental: {
        start: "#FDF3FA",
        subtitle: "#0f182680",
    },
    uncategorized: {
        start: "#E5E5E5",
        subtitle: "#0f182680",
    },
    personal: {
        start: "#BDD5FD",
        subtitle: "#0f182680",
    },
    cogs: {
        start: "#D9F0EF",
        subtitle: "#0f182680",
    },
    business_office: {
        start: "#F7E9B6",
        subtitle: "#0f182680",
    },
    charitable_contributions: {
        start: "#D5B29F",
        subtitle: "#0f182680",
    },
    assets: {
        start: "#CDF4C0",
        subtitle: "#0f182680",
    },
    // these are not main categories from the point of the UI
    rentals_leases: {
        start: "#83E4B1",
        subtitle: "#515D71",
    },
    retirement: {
        start: "#83E4B1",
        subtitle: "#515D71",
    },
    security_deposit: {
        start: "#83E4B1",
        subtitle: "#515D71",
    },
    donations: {
        start: "#83E4B1",
        subtitle: "#515D71",
    },
};
